import styled from 'styled-components';

export const Content = styled.div`
  padding: 18px 20px 20px;
  box-sizing: border-box;
  input {
    font-size: 15px;
    letter-spacing: 0.5px;
    color: #e6eaec;
    padding: 0 12px;
    height: 40px;
    box-sizing: border-box;
    border-radius: 10px;
    width: 100%;
    background: #10151a;
    border: 1px solid #3d4952;
    outline: none;
    transition:
      border-color 0.15s ease,
      box-shadow 0.15s ease;
    &:focus {
      border-color: #47b972;
      box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.16);
    }
    &::placeholder {
      color: #5a666d;
    }
  }
`;
export const TypeSelector = styled.div`
  margin: 0 0 18px;
`;

export const Label = styled.label`
  color: #aab2b8;
  font-size: 12px;
  font-weight: 500;
  display: block;
  margin: 0 0 8px;
`;

export const Buttons = styled.div`
  justify-content: space-between;
  gap: 10px;
  display: flex;
`;
